import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    Input,
    input,
    model,
    Output,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { S25ModalModule } from "../../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../../s25-modal/s25.modal.component";
import { S25FadingSuccessMsgComponent } from "../../s25-fading-success-msg/s25.fading.success.msg.component";

@Component({
    selector: "s25-ng-table-header-select-all",
    template: `
        <div>{{ label }}</div>
        <div class="button-wrapper">
            <s25-ng-button [type]="'link'" (clicked)="onAction()">{{ action() }}</s25-ng-button>
            <s25-ng-fading-success-msg [(message)]="successMessage" class="select-all-success-msg" />
        </div>

        <s25-ng-modal #confirmSelectionModal [title]="'Confirm Selection'" [type]="'confirm'" [size]="'xxs'">
            Are you sure that you want to <em>{{ allSelected() ? "deselect" : "select" }} all</em> items in the
            <em>{{ label }}</em> column?
        </s25-ng-modal>
    `,
    styles: `
        :host {
            display: grid;
            justify-items: center;
            line-height: 1.1;
        }

        em {
            font-style: normal;
            font-weight: bold;
        }

        .button-wrapper {
            position: relative;
        }

        .select-all-success-msg {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
        }

        ::ng-deep .select-all-success-msg .success-msg {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            font-size: 0.75rem;
        }

        :host:has(.select-all-success-msg.has-message) .button-wrapper > s25-ng-button {
            visibility: hidden;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent, S25ModalModule, S25FadingSuccessMsgComponent],
})
export class TableHeaderSelectAllComponent {
    @Input({ required: true }) label: string;
    // allSelected should be required, but it breaks tests
    allSelected = input<boolean>();
    action = computed(() => (this.allSelected() ? "Deselect All" : "Select All"));
    successMessage = model<string>("");

    @Output() toggle = new EventEmitter<boolean>();

    @ViewChild("confirmSelectionModal") confirmSelectionModal: S25ModalComponent;

    async onAction() {
        const ok = await this.confirmSelectionModal.open();
        if (!ok) return;

        this.toggle.emit(!this.allSelected());
    }

    showSuccess(msg: string = "Saved!") {
        // Clear first to ensure change detection triggers even if same message
        this.successMessage.set("");
        queueMicrotask(() => this.successMessage.set(msg));
    }
}
